module.exports = __webpack_public_path__ + "img/vi.0ede3aca.png";